// extracted by mini-css-extract-plugin
module.exports = {"root":"MultiRowSelect_root__-Lv8h"};